var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect } from 'react';
import Typography from '../../../typography/typography';
import * as styles from './tab.styles';
export function Tab(_a) {
    var id = _a.id, title = _a.title, tabIndex = _a.tabIndex, activeIndex = _a.activeIndex, tabSelected = _a.tabSelected, className = _a.className, isOnlyTab = _a.isOnlyTab, activeTabClassName = _a.activeTabClassName;
    var selectTabReceived = function (tab) {
        if (tabSelected) {
            tabSelected(tab);
        }
    };
    useEffect(function () {
        setTimeout(function () {
            var activeTabElement = document.querySelector("[data-tab-index=\"".concat(activeIndex, "\"]"));
            if (activeTabElement) {
                activeTabElement.scrollIntoView({
                    behavior: 'smooth',
                    block: 'nearest',
                    inline: 'nearest',
                });
            }
        }, 0);
    }, [activeIndex]);
    return (_jsx("div", __assign({ id: id, "data-tab-index": tabIndex, className: styles.getTabClass(tabIndex === activeIndex, className ? className : '', isOnlyTab, activeTabClassName), onClick: function () { return selectTabReceived(tabIndex); }, style: { width: '-webkit-fill-available' } }, { children: _jsx(Typography, { type: isOnlyTab ? 'h2' : 'h4', color: isOnlyTab
                ? 'textDark'
                : tabIndex === activeIndex
                    ? 'primary'
                    : 'primaryAccent1', text: title, className: "font-medium" }) }), "".concat(title, "-tab-") + tabIndex));
}
export default Tab;
//# sourceMappingURL=tab.js.map